import { useSingleStreetLight } from "../../../../hooks"


export default function TitlePresenter() {

  const {singleStreetLightQuery:{data}} = useSingleStreetLight()

  return (
      <>{data?.str_light_name}</>
  )
}
